<template>
    <div>
        <p class="form-header">
            {{ $t('formHeader.formHeaderStep3') }}
        </p>
        <b-form class="form" @submit.prevent="onSubmit">
            <div class="container-form">
                <div class="container-form-input">
                    <div class="mr-2 label">{{ $t('SubmissionFormStep3.coverLetter') }}</div>
                    <div class="input-container">
                        <b-form-file
                            v-model="uploadedCoverLetter"
                            :state="uploadedCoverLetter && !fileSizeError"
                            class="input-box"
                            accept=".pdf, application/pdf"
                            name="file"
                            placeholder=""
                            drop-placeholder="Σύρετε εδώ"
                            browse-text="Αναζήτηση"
                            @input="checkFileSize(uploadedCoverLetter)"
                        />
                        <div class="file-description">
                            <small class="text-muted">{{ $t('SubmissionFormStep3.description[0]') }}</small>
                            <small class="text-muted">{{ $t('SubmissionFormStep3.description[1]') }}</small>
                        </div>
                        <small
                            v-if="uploadedCoverLetter && fileSizeError"
                            class="file-size-error"
                        >
                            {{ $t('SubmissionFormStep3.bigFileSizeError') }}
                        </small>
                        <small
                            v-if="coverLetterUploadFailed"
                            class="file-size-error"
                        >
                            {{ $t('errors.somethingWentWrong') }}
                        </small>
                    </div>
                </div>
                <div class="container-form-input">
                    <div class="mr-2 label">{{ $t('SubmissionFormStep3.attachCV') }} *</div>
                    <div class="input-container">
                        <b-form-file
                            v-model="uploadedResume"
                            :state="uploadedResume && !fileSizeError"
                            class="input-box"
                            accept=".pdf"
                            name="file"
                            placeholder=""
                            drop-placeholder="Σύρετε εδώ"
                            browse-text="Αναζήτηση"
                            @input="checkFileSize(uploadedResume)"
                        />
                        <div class="file-description">
                            <small class="text-muted">{{ $t('SubmissionFormStep3.description[0]') }}</small>
                            <small class="text-muted">{{ $t('SubmissionFormStep3.description[1]') }}</small>
                        </div>
                        <small
                            v-if="uploadedResume && fileSizeError"
                            class="file-size-error"
                        >
                            {{ $t('SubmissionFormStep3.bigFileSizeError') }}
                        </small>
                        <small
                            v-if="emptyCV"
                            class="file-size-error"
                        >
                            {{ $t('errors.emptyCvError') }}
                        </small>
                        <small
                            v-if="cVUploadFailed"
                            class="file-size-error"
                        >
                            {{ $t('errors.somethingWentWrong') }}
                        </small>
                    </div>
                </div>
            </div>
            <div class="form-buttons">
                <button
                    type="submit"
                    :disabled="fileSizeError"
                    class="submit"
                    :class="{disabled: fileSizeError}"
                >
                    {{ $t('SubmissionFormStep3.submitApplication') }}
                </button>
            </div>
        </b-form>
    </div>
</template>

<script>
    import submissionService from '@/services/submission-service'

    export default {
        name: 'SubmissionFormStep3',
        data() {
            return {
                submission: {},
                uploadedCoverLetter: null,
                uploadedResume: null,
                fileSizeError: null,
                coverLetterUploadFailed: false,
                cVUploadFailed: false,
                emptyCV: false
            }
        },
        methods: {
            checkFileSize(file) {
                const limit2MB = 2 * Math.pow(1024, 2)
                if(file.size > limit2MB) {
                    this.fileSizeError = true
                } else {
                    this.fileSizeError = null
                }
            },
            async onSubmit() {
                if(!this.uploadedResume) {
                    this.emptyCV = true
                    return
                } else {
                    this.emptyCV = false
                }
                this.coverLetterUploadFailed = false
                this.cVUploadFailed = false
                if(this.uploadedCoverLetter) {
                    try {
                        this.submission.coverLetter = await submissionService.sendCoverLetter(this.uploadedCoverLetter)
                    } catch {
                        this.coverLetterUploadFailed = true
                    }
                }
                try {
                    this.submission.resume = await submissionService.sendResume(this.uploadedResume)
                } catch {
                    this.cVUploadFailed = true
                }
                if(!this.coverLetterUploadFailed && !this.cVUploadFailed) {
                    this.$emit('update', this.submission)
                    this.$emit('submit-form')
                }

            }
        }
    }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
label.custom-file-label {
    border: 0;
    border-radius: 0 !important;
    height: 100%;
}

.custom-file-input ~ .custom-file-label::after {
    content: "\21E7" !important;
    font-size: 1.5rem;
    font-weight: bolder;
    line-height: 1.5rem;
    background-color: #a0d4e9;
    color: #fff;
    border-radius: 0 !important;
}
</style>

<style scoped>
.form-header {
    text-align: center;
    max-width: 540px;
    margin: 0 auto 1rem;
    line-height: 1.7rem;
    font-weight: 300;
}

.form {
    max-width: 540px;
    margin: 2rem auto;
    border-top: 1px solid #a0d4e9;
}

.form-buttons {
    padding: 2rem 0;
    border-top: 1px solid #a0d4e9;
    display: flex;
    justify-content: center;
}

.container-form {
    display: flex;
    flex-direction: column;
    width: 90%;
    padding: 3rem 0;
    margin: 0 auto;
    min-height: 301px;
}

.container-form-input {
    flex-wrap: wrap;
    margin-bottom: 0.75rem;
    max-width: 520px;
}

.label {
    color: #279fcf;
    font-family: 'Roboto', sans-serif;
}

.input-box,
.submit {
    border-radius: 0;
    border: 2px solid #a0d4e9;
}

.file-description {
    display: flex;
    justify-content: space-between;
}

.submit {
    background-color: #fff;
    padding: 10px 50px;
    margin: 0 auto;
    color: #0089c2;
    font-size: 18px;
    white-space: nowrap;
}

.submit:hover {
    transition: all 0.15s ease-in-out;
    color: #fff;
    background: #a0d4e9;
}

.file-size-error {
    display: flex;
    color: #b11;
    text-align: center;
    justify-content: center;
}

@media screen and (min-width: 768px) {
    .form,
    .form-header {
        max-width: 730px;
    }

    .container-form {
        min-height: 365px;
    }

    .label {
        width: 20ch;
    }

    .container-form-input {
        margin-bottom: 2rem;
        width: 100%;
        max-width: none;
    }
}

@media screen and (min-width: 992px) {
    .form,
    .form-header {
        width: 90%;
        max-width: 1100px;
    }

    .input-container {
        min-height: 95px;
        width: 60%;
    }

    .container-form {
        flex-direction: row;
        min-height: 0;
        padding-bottom: 2rem;
    }

    .label {
        width: 15ch;
    }

    .container-form-input {
        display: flex;
    }
}
</style>
